<template>
    <a-affix :offsetTop="16">
        <a-button class="backButton" @click="goBack">
            <slot></slot>
        </a-button>
    </a-affix>
</template>

<script>
export default {
    methods: {
        goBack() {
            this.$router.back(-1);
        }
    }
};
</script>

<style lang="less" scoped>
.backButton {
    float: right;
}
</style>